import { render, staticRenderFns } from "./EditGroupDialog.vue?vue&type=template&id=60f6ce7a&scoped=true&"
import script from "./EditGroupDialog.vue?vue&type=script&lang=js&"
export * from "./EditGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupDialog.vue?vue&type=style&index=0&id=60f6ce7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6ce7a",
  null
  
)

export default component.exports